import React, { useState } from 'react';
import axios from 'axios';
import apiURL from './Config';

const FileUpload = ({ onDataFetched, onValidationErrors }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState('');

  // Handle file selection
  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  // Handle file upload
  const handleUpload = () => {
    if (files.length === 0) {
      alert('Please select files to upload.');
      return;
    }

    setUploading(true);
    setUploadProgress(`Uploading... Please wait (0/${files.length} files)`);

    let completedFiles = 0;
    let allValidationErrors = [];

    const uploadPromises = files.map((file, index) => {
      const formData = new FormData();
      formData.append('file', file);

      return axios
        .post(`${apiURL}/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 600000, // 10 minutes timeout for large files
          validateStatus: (status) => status < 500, // Accept 207 as valid response
        })
        .then((response) => {
          completedFiles++;
          setUploadProgress(`Processing... Please wait (${completedFiles}/${files.length} files done)`);
          console.log(`File ${file.name} uploaded successfully.`);

          // Check for validation errors (status 207 = partial success)
          if (response.status === 207 && response.data.validationErrors) {
            allValidationErrors.push({
              fileName: file.name,
              errors: response.data.validationErrors,
              message: response.data.message,
              validCount: response.data.validData ? response.data.validData.length : 0
            });
          }
        })
        .catch((error) => {
          completedFiles++;
          setUploadProgress(`Processing... Please wait (${completedFiles}/${files.length} files done)`);
          console.error(`Error uploading file ${file.name}:`, error);
          
          if (error.code === 'ECONNABORTED') {
            alert(`File "${file.name}" upload timed out. The file may be too large. Please try again.`);
          }
        });
    });

    Promise.all(uploadPromises)
      .then(() => {
        // If there were validation errors, pass them to parent
        if (allValidationErrors.length > 0 && onValidationErrors) {
          onValidationErrors(allValidationErrors);
        }

        onDataFetched(); // Refresh data
        
        if (allValidationErrors.length === 0) {
          alert('All files uploaded and data processed successfully!');
        }
        // If there are validation errors, the dialog in DataTable will show them
      })
      .catch(() => {
        alert('Error uploading files. Please try again.');
      })
      .finally(() => {
        setUploading(false);
        setUploadProgress('');
      });
  };

  return (
    <div className="file-upload">
      <input type="file" multiple onChange={handleFileChange} disabled={uploading} />
      <button onClick={handleUpload} disabled={uploading}>
        {uploading ? 'Uploading...' : 'Upload'}
      </button>

      {/* Loading Overlay */}
      {uploading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          color: 'white',
        }}>
          <div style={{
            border: '4px solid rgba(255,255,255,0.3)',
            borderTop: '4px solid white',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 1s linear infinite',
          }} />
          <p style={{ marginTop: '20px', fontSize: '18px', fontWeight: 'bold' }}>
            {uploadProgress}
          </p>
          <p style={{ fontSize: '14px', opacity: 0.8 }}>
            Do not close or refresh this page
          </p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      )}
    </div>
  );
};

export default FileUpload;